export default "__VITE_ASSET__CZOl2UGG__"